import { render, staticRenderFns } from "./PersonTableEntry.vue?vue&type=template&id=b95437d6&"
import script from "./PersonTableEntry.vue?vue&type=script&lang=js&"
export * from "./PersonTableEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonTableEntry.vue"
export default component.exports